<div class="box ml-2 mr-2">
  <div class="box-header p-3">
    <div class="row">
      <div class="col-md-6">
        <table class="table col-sm-12">
          <tbody>
            <tr>
              <td class="font-weight-bold colon">
                {{'Store #' | translate}}
              </td>
              <td>{{orderdetailsresponse.storeNumber}}</td>
            </tr>
            <tr>
              <td class="font-weight-bold colon">
                {{'DC Location' | translate}}
              </td>
              <td>{{orderdetailsresponse.dcAddress}}</td>
            </tr>
            <tr>
              <td class="font-weight-bold colon">
                {{'RC #' | translate}}
              </td>
              <td>{{orderdetailsresponse.purchaseOrder}}</td>
            </tr>
            <tr>
              <td class="font-weight-bold colon">
                {{'RC Date' | translate}}
              </td>
              <td>{{orderdetailsresponse.poCreatedTime | date : dateFormat :'' : 'fr'}}</td>
            </tr>
            <tr>
              <td class="font-weight-bold colon">
                {{'Status' | translate}}
              </td>
              <td>
                @if (orderdetailsresponse.status !== 5) {
                  <label>  {{ orderdetailsresponse.statusName | translate}} </label>
                }
                @if (orderdetailsresponse.status === 5) {
                  <label>  {{ 'Signed' | translate}} </label>
                }

              </td>
            </tr>

          </tbody>
        </table>
      </div>
      <div class="col-md-6 text-right">
        <button (click)="backToRC()" mat-raised-button >{{'Back to RC Details' | translate}}</button>
      </div>
    </div>
  </div>
  <div>
    <mat-table [dataSource]="orderdetailsresponse.orderDetailsDtoList" class="mat-elevation-z8">
      <!-- Position Column -->
      <ng-container matColumnDef="productdescription">
        <mat-header-cell *matHeaderCellDef> {{'Product Description' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.itemDescription }} </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="orderedquantity">
        <mat-header-cell *matHeaderCellDef> {{'Order Qty' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.orderedQuantity }} </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="orderqty">
        <mat-header-cell *matHeaderCellDef>  {{'Shipped Qty' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.quantity }} </mat-cell>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="upc">
        <mat-header-cell *matHeaderCellDef> {{'UPC' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.itemNumber}} </mat-cell>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="din">
        <mat-header-cell *matHeaderCellDef > {{'DIN' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.din?  element.din : '--' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="orderunit">
        <mat-header-cell *matHeaderCellDef> {{'Pack Size' | translate}} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.packageSize ? element.packageSize : '--' }} </mat-cell>
      </ng-container>



      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>


    <form [formGroup]="reportSummaryForm">
      <div class="row p-3">
        <div class="col flex-align-center">
          <mat-form-field appearance="outline">
            <mat-label>{{'Actual Qty Received' | translate}}</mat-label>
            <input matInput  formControlName="actualquantity" min="0"  maxlength="3"  type="text" pattern="\d+"/>
          </mat-form-field>
        </div>
        <div class="col flex-align-center">
          <mat-form-field appearance="outline" matTooltip="{{'Reason_Tooltip' | translate}}" >
            <mat-label>{{'Reason' | translate}}</mat-label>
            <mat-select formControlName="reason" (selectionChange)="changeStaus($event)">
              <mat-option value=''> {{'Select' | translate}} </mat-option>
              <mat-option value="Product Not Ordered"> {{'Product Not Ordered' | translate}} </mat-option>
              <mat-option value="Order Not Received"> {{'Order Not Received' | translate}}  </mat-option>
              <mat-option value="Shortage"> {{'Shortage' | translate}} </mat-option>
              <mat-option value="Overage"> {{'Overage' | translate}} </mat-option>

            </mat-select>
          </mat-form-field>
        </div>
        <div class="col flex-align-center justify-md-right">
          <mat-form-field class="col-md-8" appearance="outline" matTooltip="{{'Notes_Tooltip' | translate}}">
            <mat-label>{{'Notes' | translate}}</mat-label>
            <textarea  formControlName="notes" matInput #input maxlength="250"></textarea>
            <mat-hint align="end">{{ input.value?.length || 0 }}/250</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="row px-3 mb-4">
        <div class="col">
          <div class="font-weight-bold text-left px-3 py-2">
            <tr>
              <td>
                {{'RC-Note1' | translate}}
              </td>
            </tr>
            <tr>
              <td>
                {{'RC-Note2' | translate}}
              </td>
            </tr>

          </div>
        </div>
        <div class="col">
          <div class="text-right">
            <button  mat-raised-button class="ml-auto" (click)="updateDetails()" [disabled]="!reportSummaryForm.valid  || ocRcButtonEnable">{{'Save' | translate}}</button>
          </div>
        </div>
      </div>
    </form>

  </div>



</div>
